import { Box, LinearProgress, Theme, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { Order, PaginationObj, SortingObj, TableHeaderData } from '../types';
import { getNonMfTranDetailsResBody, GetTransactionDetailsResponseBody, NonMfTransactionDetailsData, TransactionDetailsData } from '../../../redux-store/types/products';
import CustomTable from './customTable';
import MutualFundTranscationBody from '../../dashboard/table/MutualFundTranscationBody';
import NonMFTransactionBody from './NonMFTransactionBody';
import { NO_DATA_ERROR_MESSAGE_TRANSACTION, NON_MF_FUNDS_FILTER } from '../../../utils/constant';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const tableHeaderData: TableHeaderData[] = [
  {
    id: "customer",
    label: "CUSTOMER",
    align: "left",
    isSortable: false
  },
  {
    id: "portfolio",
    label: "PORTFOLIO",
    align: "center",
    isSortable: false
  },
  {
    id: "security",
    label: "SECURITY",
    align: "center",
    isSortable: false
  },
  {
    id: "quantity",
    label: "UNITS",
    align: "center",
    isSortable: false
  },
  {
    id: "bookCost",
    label: "BOOK COST",
    align: "center",
    isSortable: false
  },
  {
    id: "grossAmount",
    label: "GROSS AMOUNT",
    align: "center",
    isSortable: false
  },
  // {
  //   id: "transName",
  //   label: "TRANSACTION NAME",
  //   align: "center",
  //   isSortable: false
  // },
  {
    id: "transName",
    label: "TRANSACTION TYPE",
    align: "center",
    isSortable: false
  },
  {
    id: "transDate",
    label: "TRANSACTION DATE",
    align: "center",
    isSortable: false
  },
]

interface FetchDataArgs {
  sortItem?: string;
  order?: Order;
  currentPage?: number;
  rowsPerPage?: number;
}

interface TransactionDetailProps {
  transactionDetailsLoading: boolean;
  setTransactionDetailsLoading: React.Dispatch<React.SetStateAction<boolean>>
  transactionTableData: NonMfTransactionDetailsData[];
  setTransactionTableData: React.Dispatch<React.SetStateAction<NonMfTransactionDetailsData[]>>
  transactionDetailPaginationObj: PaginationObj;
  setTransactionDetailPaginationObj: React.Dispatch<React.SetStateAction<PaginationObj>>
  fetchTransactionDetailsData: any
  transactionDetailsData: getNonMfTranDetailsResBody
  allTransactionsData: NonMfTransactionDetailsData[]
  isShowFilter?: boolean
}


export default function NonMFTransactionDetails(props: TransactionDetailProps): JSX.Element {
  const { transactionDetailsLoading, transactionTableData, transactionDetailPaginationObj, setTransactionDetailPaginationObj, fetchTransactionDetailsData, transactionDetailsData, setTransactionTableData, allTransactionsData, isShowFilter = true } = props;

  const { palette } = useTheme()
  const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
    order: "desc",
    orderBy: "date"
  });
  const [selectedFilter, setSelectedFilter] = useState<string | null>('ALL');


  const handleSort = (orderBy: string, order: Order) => {
    setTableSortingObj({
      order,
      orderBy
    })

    fetchTransactionDetailsData({
      sortItem: orderBy,
      order,
      currentPage: transactionDetailPaginationObj.currentPage + 1,
      rowsPerPage: transactionDetailPaginationObj.rowsPerPage
    })
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTransactionDetailPaginationObj(prevState => ({
      ...prevState,
      rowsPerPage: Number(event.target.value),
      currentPage: 0,
    }))

    fetchTransactionDetailsData({
      rowsPerPage: Number(event.target.value),
      sortItem: tableSortingObj.orderBy,
      order: tableSortingObj.order,
    })
  }

  const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    setTransactionDetailPaginationObj(prevState => ({
      ...prevState,
      currentPage: page
    }))

    fetchTransactionDetailsData({
      currentPage: page + 1,
      sortItem: tableSortingObj.orderBy,
      order: tableSortingObj.order,
      rowsPerPage: transactionDetailPaginationObj.rowsPerPage
    })
  }

  const handleFilterSelection = (val: string) => {
    setSelectedFilter(val);
    if (!val || !allTransactionsData.length) {
      return;
    }
    if (val === "ALL") {
      setTransactionTableData(allTransactionsData);
      return;
    }
    setTransactionTableData(allTransactionsData.filter(item => item.dataSource === val));
  }

  return (
    <>
      <Box
        p={{ xs: '15px', md: '25px' }}
        boxShadow={1}
        sx={{
          background: palette.background.paper,
          borderRadius: '25px',
          border: `3px solid ${palette.stroke.main}`,
        }}
      >
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body_400" sx={{ lineHeight: "35px", color: palette.text.primary }}>Upto 30 days of Transaction</Typography>
            {isShowFilter && <FormControl sx={{ minWidth: 100, float: "right", borderRadius: "15px", maxWidth: "200px", alignSelf: "flex-end" }}>
              <Select
                labelId="filter-label"
                id="filter-select"
                value={selectedFilter}
                onChange={(e) => handleFilterSelection(e.target.value ?? 'ALL')}
                sx={{ borderRadius: "8px", maxHeight: "45px" }}
              >
                {NON_MF_FUNDS_FILTER.map((filter) => (
                  <MenuItem key={filter.value} value={filter.value}>
                    {filter.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
          </Box>
          
          <CustomTable
            isLoading={transactionDetailsLoading}
            tableBody={
              <NonMFTransactionBody
                tableBodyData={transactionTableData}
                tableBodyRowCustomStyles={{
                  '& td:first-child': {
                    paddingLeft: "0px",
                  },
                  '& td': {
                    padding: "16px",
                  },
                }}
              />
            }
            tableData={transactionTableData}
            tableHeaderData={tableHeaderData}
            handleSort={handleSort}
            tableDataCount={transactionTableData.length}
            rowsPerPage={transactionDetailPaginationObj.rowsPerPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            handleRowsPerPageChange={handleRowsPerPageChange}
            handlePageChange={handlePageChange}
            currentPage={transactionDetailPaginationObj.currentPage}
            order={tableSortingObj.order}
            orderBy={tableSortingObj.orderBy}
            isPaginationVisible={false}
            tableHeadRowCustomStyles={{
              '& th:first-child': {
                paddingLeft: "0px"
              }
            }}
            tableBodyCustomStyles={{
              '& tr:last-child td': {
                border: '1px'
              }
            }}
          />
        </Box>
        {/* {(!transactionDetailsLoading && !transactionDetailsData?.isSuccess) ? <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}
        >
          <Typography
            variant="body_600"
            sx={(theme: Theme) => ({
              fontWeight: 500,
              lineHeight: "22.5px",
              letterSpacing: "0.01px",
              color: theme.palette.text.primary
            })}
          >
          {NO_DATA_ERROR_MESSAGE_TRANSACTION}
          </Typography>
        </Box> :
          <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="body_400" sx={{ lineHeight: "35px", color: palette.text.primary }}>Upto 30 days of Transaction</Typography>
              {isShowFilter && <FormControl sx={{ minWidth: 100, float: "right", borderRadius: "15px", maxWidth: "200px", alignSelf: "flex-end" }}>
                <Select
                  labelId="filter-label"
                  id="filter-select"
                  value={selectedFilter}
                  onChange={(e) => handleFilterSelection(e.target.value ?? 'ALL')}
                  sx={{ borderRadius: "8px", maxHeight: "45px" }}
                >
                  {NON_MF_FUNDS_FILTER.map((filter) => (
                    <MenuItem key={filter.value} value={filter.value}>
                      {filter.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>}
            </Box>

            <CustomTable
              isLoading={transactionDetailsLoading}
              tableBody={
                <NonMFTransactionBody
                  tableBodyData={transactionTableData}
                  tableBodyRowCustomStyles={{
                    '& td:first-child': {
                      paddingLeft: "0px",
                    },
                    '& td': {
                      padding: "16px",
                    },
                  }}
                />
              }
              tableData={transactionTableData}
              tableHeaderData={tableHeaderData}
              handleSort={handleSort}
              tableDataCount={transactionDetailPaginationObj.totalRows}
              rowsPerPage={transactionDetailPaginationObj.rowsPerPage}
              rowsPerPageOptions={[5, 10, 15, 20]}
              handleRowsPerPageChange={handleRowsPerPageChange}
              handlePageChange={handlePageChange}
              currentPage={transactionDetailPaginationObj.currentPage}
              order={tableSortingObj.order}
              orderBy={tableSortingObj.orderBy}
              isPaginationVisible={false}
              tableHeadRowCustomStyles={{
                '& th:first-child': {
                  paddingLeft: "0px"
                }
              }}
              tableBodyCustomStyles={{
                '& tr:last-child td': {
                  border: '1px'
                }
              }}
            />
          </Box>
        } */}
      </Box >
    </>
  )
}
